// API Configuration for different environments
// This file provides centralized API configuration and fallback URLs

const isDev = process.env.NODE_ENV === 'development';
const isProd = process.env.NODE_ENV === 'production';

// Available API endpoints in order of preference
const API_ENDPOINTS = {
  development: [
    'http://localhost:5001/api',
    'http://localhost:8080/api', 
    'https://us-central1-tunno-haubuah-wedding.cloudfunctions.net/api',
    'https://api-iqucz6wsoq-uc.a.run.app'
  ],
  production: [
    'https://us-central1-tunno-haubuah-wedding.cloudfunctions.net/api',
    'https://api-iqucz6wsoq-uc.a.run.app',
    'https://api-1005088542904.us-central1.run.app'
  ]
};

// Get the configured API base URI from environment variables
const getConfiguredApiUrl = () => {
  return process.env.REACT_APP_API_BASE_URI;
};

// Get fallback URLs for the current environment
const getFallbackUrls = () => {
  return isDev ? API_ENDPOINTS.development : API_ENDPOINTS.production;
};

// Get the primary API URL
export const getApiBaseUrl = () => {
  const configuredUrl = getConfiguredApiUrl();
  
  if (configuredUrl) {
    console.log(`Using configured API URL: ${configuredUrl}`);
    return configuredUrl;
  }
  
  // Fallback to first endpoint in the list
  const fallbackUrls = getFallbackUrls();
  const fallbackUrl = fallbackUrls[0];
  
  console.warn(`No API URL configured, using fallback: ${fallbackUrl}`);
  return fallbackUrl;
};

// Get all available URLs for the current environment (for health checking)
export const getAllApiUrls = () => {
  const configuredUrl = getConfiguredApiUrl();
  const fallbackUrls = getFallbackUrls();
  
  // Remove duplicates and return unique URLs
  const allUrls = configuredUrl ? [configuredUrl, ...fallbackUrls] : fallbackUrls;
  return [...new Set(allUrls)];
};

// Environment information
export const ENV_INFO = {
  isDevelopment: isDev,
  isProduction: isProd,
  nodeEnv: process.env.NODE_ENV
};

// Log configuration on import
console.log('API Configuration:', {
  environment: process.env.NODE_ENV,
  configuredUrl: getConfiguredApiUrl(),
  primaryUrl: getApiBaseUrl(),
  availableUrls: getAllApiUrls()
});

export default {
  getApiBaseUrl,
  getAllApiUrls,
  ENV_INFO
};